import { InjectionToken, WritableSignal } from '@angular/core';

export const AIDA_DISPLAY_NAME: InjectionToken<WritableSignal<string>> = new InjectionToken('AIDA_DISPLAY_NAME');
